import React, { Fragment, useState, useEffect, useContext } from "react";
import { collectionColumns } from "../../../Data/Driver/DriverWallet";
import CommonDataTable from "../../Common/Component/CommonDataTable";
import {
    getDriverCollectionAmounts
} from "../../../Services/Driver.service";
import { formatDateTime, showAlert } from "../../../Services/Shared.service";
import DataTable from "react-data-table-component";
import moment from "moment";
import { Spinner } from "../../../AbstractElements";
import SharedDataContext from "../../../_helper/SharedData";
import CustomizerContext from "../../../_helper/Customizer";
const DriverCollectableAmount = ({ collectionsData,onChangePage,onChangeRowsPerPage,rowsPerPage,paginationTotalRows,loader }) => {
    const {mix_background_layout} = useContext(CustomizerContext)

    return (
        <Fragment>
            <div className="table-responsive driver-wallet-table">
                <DataTable
                    columns={collectionColumns}
                    data={collectionsData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={'50vh'}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    paginationServer
                    pagination
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "50vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                     theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
        </Fragment>
    );
};

export default DriverCollectableAmount;
